export default "__VITE_ASSET__DDtfnMwm__"